<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form  :inline="true" :model="searchForm" ref="searchForm" label-width="70px" size="mini">
          <el-form-item label="模板名称" prop="tmpName">
            <el-input class="form-input" v-model="searchForm.tmpName"  clearable></el-input>
          </el-form-item>
          <el-form-item label="模板状态" prop="tmpStatus">
            <el-select v-model="searchForm.tmpStatus"  clearable @change="onSearch">
              <el-option v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建人" prop="createdBy">
            <el-input class="form-input" v-model="searchForm.createdBy"  clearable></el-input>
          </el-form-item>
          <el-form-item label="创建日期" prop="createdTime">
            <q-date-picker startFiled="createTimeStart" endFiled="createTimeEnd" :isDefault="false" v-model="searchForm" ref="dateRef" />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="small" @click="handleAdd(null, 1)">新增</el-button>
      </template>
      <el-table
        stripe
        v-loading="loading"
        ref="tableRef"
        highlight-current-row
        border
        :data="tableData"
        :height="maxTableHeight"
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column prop="tmpName" label="模板名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="tmpDesc" label="模板描述" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createdBy" label="创建人" width="100" align="center"></el-table-column>
        <el-table-column prop="createdTime" label="创建方式" width="130" align="center">
          <template slot-scope="scope">
            {{scope.row.creationMethod | creationMethod}}
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="创建时间" width="155">
          <template slot-scope="scope">
            {{scope.row.createdTime | dateFormat}}
          </template>
        </el-table-column>
        <el-table-column prop="tmpTags" label="标签" show-overflow-tooltip></el-table-column>
        <el-table-column prop="tmpStatus" label="模板状态" width="80" align="center">
          <template slot-scope="scope">
            {{scope.row.tmpStatus | statusEnum}}
          </template>
        </el-table-column>
        <el-table-column label="操作"  class-name="action-column" align="center" width="280">
          <template v-slot="scope">
            <el-button v-if="scope.row.tmpStatus == 0" type="text" size="small" @click="handleState(scope.row, 1)">下线</el-button>
            <el-button v-else type="text" size="small" @click="handleState(scope.row, 0)">上线</el-button>
            <template v-if="scope.row.tmpStatus == 1">
              <el-button type="text" size="small" @click="handleAdd(scope.row, 2)">修改</el-button>
              <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
            </template>
            <el-button type="text" size="small" @click="handleAdd(scope.row, 3)">查看</el-button>
            <el-button type="text" size="small" v-if="scope.$index != 0" @click="moveUp(scope.$index)">上移</el-button>
            <el-button type="text" size="small" v-if="scope.$index != tableDataLength-1"  @click="moveDown(scope.$index)">下移</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right;">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onNumChange"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            :page-sizes="[20, 50, 100, 200]"
            layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </div>
      </template>
    </table-panel>
    <creation-mode :isVisible.sync="isCreationMode" @createMode="createMode"/>
    <add-template 
      v-if="isShowAdd" 
      :visible.sync="isShowAdd" 
      :modifyData="modifyData" 
      :actionType="actionType"
      :creationMethod="creationMethod"
      @success="getList"
    />
  </content-panel>
</template>

<script>
import AddTemplate from './add-template.vue'
import creationMode from './creation-mode.vue'
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
export default {
  name: 'TemplateList',
  mixins: [tableMixin,pagePathMixin],
  components: {
    AddTemplate,
    creationMode
  },
  data() {
    return {
      searchForm: {
        tmpName: '',
        status: '',
        createdBy: '',
        createTimeStart: "",
        createTimeEnd: "",
      },

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      statusOptions: [
        {value: '', label: '全部'},
        {value: 0, label: '使用中'},
        {value: 1, label: '已下线'},
      ],
      isCreationMode: false,
      isShowAdd: false,
      modifyData: null,
      actionType: 1,
      creationMethod: {
        creationMethod: 1,
        tmpType: '1'
      }
    }
  },
  computed: {
    tableDataLength() {
      return this.tableData.length
    },
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam
        }
      }
      this.$api.templateMgmt.getTemplateList(params)
        .then(({data: {list, total}}) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== 'undefined' && val !== null && val !== '') {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.createTimeStart = ''
      this.searchForm.createTimeEnd = ''
      this.$refs.dateRef.reset()
    },
    handleAdd(row, actionType) {
      this.modifyData = row || null;
      this.actionType = actionType;
      if (actionType == 1) {
        this.isCreationMode = true
      }else {
        this.creationMethod = {creationMethod:row.creationMethod || 1, tmpType: row.tmpType || '1'}
        this.isShowAdd = true;
      }
    },
    handleState(row, state) {
      this.$api.templateMgmt
        .updateTemplateState(row.tmpId, state)
        .then(({data}) => {
          this.$notify.success({
            title: '成功',
            message: '操作成功',
          });
          this.getList();
        });
    },
    handleDelete(row) {
      this.$confirm('删除后，已创建的活动不受影响，删除模板不可恢复，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.templateMgmt
            .updateTemplateState(row.tmpId, 2)
            .then(({data}) => {
              this.$notify.success({
                title: '成功',
                message: '删除成功',
              });
              this.getList();
            });
        })
        .catch(() => {});
    },
    moveUp(index) { 
      this.$api.common.removeSeq({
        businessCode: 'activityTmp',
        fromKey:  this.tableData[index].tmpId,
        fromSeq: this.tableData[index].seqNumber,
        toKey: this.tableData[index-1].tmpId,
        toSeq: this.tableData[index-1].seqNumber,
      }).then(res =>{
        this.getList();
      })
      // this.tableData[index] = this.tableData.splice(index-1, 1, this.tableData[index])[0]
    },
    moveDown(index){
      this.$api.common.removeSeq({
        businessCode: 'activityTmp',
        fromKey:  this.tableData[index].tmpId,
        fromSeq: this.tableData[index].seqNumber,
        toKey: this.tableData[index+1].tmpId,
        toSeq: this.tableData[index+1].seqNumber,
      }).then(res => {
        this.getList();
      })
      // this.tableData[index] = this.tableData.splice(index+1, 1, this.tableData[index])[0]
    },
    createMode(creationMethod) {
      this.creationMethod = creationMethod
      this.isShowAdd = true;
    }
  },
  filters: {
    statusEnum(val) {
      const map = {
        0: '使用中',
        1: '已下线',
        2: '已删除',
      };
      return map[val] || '';
    },
    creationMethod(type) {
      return type == 2 ? '新创建方式' : '旧创建方式'
    }
  },
  mounted() {
    this.init();
  }
}
</script>

<style lang="stylus" scoped>
  .date-input {
    width 130px !important
  }
  .to {
    display: inline-block;
    margin: 0 4px;
  }
</style>